import { BusinessCardStack } from './business-card-stack';
import { CardData } from '../../../../print-cards/card-data';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { KoanBusinessCardStackBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/business-cards-2x3/koan-business-card-stack-background/koan-business-card-stack-background.component';
import { KoanBusinessCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/business-cards-2x3/koan-business-card-stack-content/koan-business-card-stack-content.component';

export class KoanBusinessCardStack extends BusinessCardStack {
  getCardHeightInInches(): number {
    return 2.5;
  }

  getCardWidthInInches(): number {
    return 3.5;
  }

  getCardBackgroundComponent(data: CardData): Type<CardBackgroundComponent> | null {
    return KoanBusinessCardStackBackgroundComponent;
  }

  getCardContentComponent(cardData: CardData): Type<PrintCardContentComponent> | null {
    return KoanBusinessCardStackContentComponent;
  }
}
